import {ModalContent, ModalFooter, ModalTitle, Button, TextRegular} from '@hm/fundamental'
import {mdiArrowRight} from '@mdi/js'
import React from 'react'
import {useTranslation} from 'react-i18next'

import HPRoduceImage from '../../assets/hproduce-united.svg'

interface IntroStepProps {
  onContinue: () => void
}

export const IntroStep: React.FC<IntroStepProps> = ({onContinue}) => {
  const {t} = useTranslation()
  return (
    <>
      <div className="flex flex-row items-center justify-center w-full pb-6">
        <img src={HPRoduceImage} alt="All hproduce apps coming together" className="max-w-xs" />
      </div>
      <ModalTitle>{t('suite.welcomeFlow.introTitle')}</ModalTitle>
      <ModalContent>
        <TextRegular>{t('suite.welcomeFlow.introDescription')}</TextRegular>
      </ModalContent>
      <ModalFooter justifyClass="justify-center">
        <Button
          variant="primary"
          iconSuffix={mdiArrowRight}
          onClick={onContinue}
          data-cy="welcome_flow_continue_button"
        >
          {t('button.continue')}
        </Button>
      </ModalFooter>
    </>
  )
}
